module.exports = __webpack_public_path__ + "components/flag/static/square/ta-628e69863e50108991d23b56da957893.svg";